export function isElementInViewport(el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }

  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function onVisibilityChange(el, callback) {
  return () => {
    if (isElementInViewport(el) && typeof callback === "function") {
      callback();
    }
  };
}

export function sendCPCLog(anchors, logType, cpcType) {
  if (TMON.view_mode === 'app') {
    TMON.data.Log.sendCPCCallApp(anchors, logType, cpcType);
  } else {
    TMON.data.Log.sendCPCLog(anchors, logType, cpcType);
  }
}
